<div style="font-size: 1.8em; font-family: monospace; letter-spacing: 3px">
    <span *ngIf="part1" [attr.data-cy]="'ooo_span_1'">{{ part1 }}</span>
    <span *ngIf="part2" style="font-weight: bold; letter-spacing: 5px" [attr.data-cy]="'ooo_span_2'">{{ part2 }}</span>
    <span *ngIf="part3" [attr.data-cy]="'ooo_span_3'">{{ part3 }}</span>
</div>
